import http from '../../services/http';
import forResponse from '../../utils/forResponse';
import { FANZONES } from '../../constants/apiUrls/apiUrls';


export const getFanzones = () => forResponse(http.get(FANZONES));
